[
	{
		"titleText": "Precipitate Dislocation Model from Brown and Ham",
		"tags": ["metallurgy"],
		"applicationURL": "https://github.com/signaloid/Signaloid-Demo-Metallurgy-BrownHamModel",
		"demoVideoURL": "https://user-images.githubusercontent.com/86417/158057589-18e8915d-e5b8-40b8-87ab-fd93005ee60d.mov"
	},
	{
		"titleText": "Battery State of Charge Estimation",
		"tags": ["robotics", "power-electronics"],
		"applicationURL": "https://github.com/signaloid/Signaloid-Demo-Batteries-StateOfChargeEstimation"
	},
	{
		"titleText": "A* Search Algorithm",
		"tags": ["robotics", "path-planning"],
		"applicationURL": "https://github.com/signaloid/Signaloid-Demo-Robotics-AStarSearch"
	},
	{
		"titleText": "C Project Template",
		"tags": ["template"],
		"applicationURL": "https://github.com/signaloid/Signaloid-Demo-General-C"
	}
]
